import script from "./AiWorkflowStudio.vue?vue&type=script&setup=true&lang=js"
export * from "./AiWorkflowStudio.vue?vue&type=script&setup=true&lang=js"

import "./AiWorkflowStudio.vue?vue&type=style&index=0&id=ac01b21e&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/cs/cs-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac01b21e"]])

export default __exports__